import React, { Component } from "react";
import PropTypes from "prop-types";

/**
 * Component that limits the number of it's children shown
 * and adds a link to 'Show citations'/'Hide citations'
 *
 * Props:
 *      showMore{int} - required: the number of items to show by default
 *      component{string} - default="div": the component type to wrap the items
 */
export default class Citations extends Component {
  constructor() {
    super();
    this.state = { showCitations: false };
  }

  toggleCitations() {
    const { showCitations } = this.state;
    this.setState({ showCitations: !showCitations });
  }

  render() {
    let citations;
    const { children, alwaysOpen } = this.props;
    const { showCitations } = this.state;

    if (children) {
      citations = (
        <div>
          {!alwaysOpen && (
            <div className="varsome-clearfix">
              <a
                className="varsome-right tw-cursor-pointer"
                onClick={this.toggleCitations.bind(this)}
              >
                <small>
                  {showCitations ? (
                    <span>
                      {"Hide citations "}
                      <i className="varsome-icons icon-chevron-up" />
                    </span>
                  ) : (
                    <span>
                      {"Show citations "}
                      <i className="varsome-icons icon-chevron-down" />
                    </span>
                  )}
                </small>
              </a>
            </div>
          )}
          {(alwaysOpen || showCitations) && (
            <div className="varsome-citations">{children}</div>
          )}
        </div>
      );
    }

    return citations;
  }
}

Citations.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.shape({})),
    PropTypes.element,
  ]),
  alwaysOpen: PropTypes.bool,
};

Citations.defaultProps = {
  children: null,
  alwaysOpen: false,
};
